import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import TextLink from '@narvar/nth-text-link';

const mapStateToProps = ({
  retailerSettings: {
    branding: {
      link_color: linkColor,
      link_hover_color: linkHoverColor,
      brand_call_to_action: ctaColor,
    } = {},
  } = {},
  language: {
    'returns.printerless_error_page.code_retrieval_error_text': codeRetrievalErrorText,
    'returns.printerless_error_page.try_again_link_text': tryAgainLinkText,
    'returns.printerless_error_page.customer_service_contact_text': customerServiceContactText,
    'returns.printerless_error_page.customer_service_contact_link_href':
      customerServiceContactLinkHref,
    'returns.printerless_error_page.customer_service_contact_link_text':
      customerServiceContactLinkText,
    'returns.printerless_error_page.customer_service_phone_contact_text':
      customerServicePhoneContactText,
  } = {},
}) => ({
  linkColor,
  linkHoverColor,
  ctaColor,
  codeRetrievalErrorText,
  tryAgainLinkText,
  customerServiceContactText,
  customerServiceContactLinkHref,
  customerServiceContactLinkText,
  customerServicePhoneContactText,
});

const PrinterlessCustomerSupport = ({
  linkColor,
  linkHoverColor,
  ctaColor,
  codeRetrievalErrorText,
  tryAgainLinkText,
  customerServiceContactText,
  customerServiceContactLinkHref,
  customerServiceContactLinkText,
  customerServicePhoneContactText,
}) => (
  <div style={{ padding: '3rem 6rem 4rem' }}>
    <div style={{ marginBottom: '2rem' }}>
      <p style={{ fontSize: '1.25rem' }}>{codeRetrievalErrorText}</p>
      <TextLink
        href={window.location.href}
        s={{
          color: linkColor,
          hoverColor: linkHoverColor,
          textDecoration: 'underline',
        }}
      >
        {tryAgainLinkText}
      </TextLink>
    </div>
    {(customerServiceContactLinkHref || customerServicePhoneContactText) && (
      <div
        style={{
          border: `1px solid ${ctaColor}`,
          padding: '2rem 0',
        }}
      >
        <div style={{ marginBottom: '0.625rem' }}>
          <p>{customerServiceContactText}</p>
          {customerServiceContactLinkHref && (
            <TextLink
              href={customerServiceContactLinkHref}
              target="_blank"
              s={{
                color: linkColor,
                hoverColor: linkHoverColor,
                textDecoration: 'underline',
              }}
            >
              {customerServiceContactLinkText}
            </TextLink>
          )}
        </div>
        {customerServicePhoneContactText && (
          <p
            style={{
              marginBottom: 0,
              fontWeight: 'bold',
            }}
          >
            {customerServicePhoneContactText}
          </p>
        )}
      </div>
    )}
  </div>
);

PrinterlessCustomerSupport.defaultProps = {
  linkColor: '',
  linkHoverColor: '',
  ctaColor: '',
  codeRetrievalErrorText: 'There was an issue retrieving your Mobile Return Code.',
  tryAgainLinkText: 'Try Again',
  customerServiceContactText: "If you aren't able to get your code, contact customer service.",
  customerServiceContactLinkHref: '',
  customerServiceContactLinkText: 'Customer Service Link',
  customerServicePhoneContactText: '',
};

PrinterlessCustomerSupport.propTypes = {
  linkColor: PropTypes.string,
  linkHoverColor: PropTypes.string,
  ctaColor: PropTypes.string,
  codeRetrievalErrorText: PropTypes.string,
  tryAgainLinkText: PropTypes.string,
  customerServiceContactText: PropTypes.string,
  customerServiceContactLinkHref: PropTypes.string,
  customerServiceContactLinkText: PropTypes.string,
  customerServicePhoneContactText: PropTypes.string,
};

export { PrinterlessCustomerSupport, mapStateToProps };
export default connect(mapStateToProps)(PrinterlessCustomerSupport);
